import { render } from "./AsRenewModal.vue?vue&type=template&id=5bd5935a&scoped=true&ts=true"
import script from "./AsRenewModal.vue?vue&type=script&lang=ts"
export * from "./AsRenewModal.vue?vue&type=script&lang=ts"

import "./AsRenewModal.vue?vue&type=style&index=0&id=5bd5935a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd5935a"]])

export default __exports__